<template>
  <div class="hidden-sm-and-up bg">
    <div class="mobile_callme_wrap">
      <p>
        Copyright ©2024 弘绿元 . All Rights Reserved .
        沪ICP备2025135305号
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.bg{
  background: url('../../assets/img/callme2.jpg') 0 0 no-repeat;
  background-size: cover;
}
.mobile_callme_wrap{
  width: 100%;
  height: 100PX;
  margin-top: 20PX;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30PX;
  box-sizing: border-box;
  p{
    font-size: 12PX;
    color: #fff;
    line-height: 18PX;
  }
}
.navigate_wrap {
  width: 100%;
  margin-top: 40px;
  padding: 0 10PX 20PX 10PX;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // word-break: keep-all;
  // word-wrap: break-word;
  a {
    color: #ccc;
    font-size: 13PX;
    margin-right: 11PX;
    text-decoration: underline;
  }
  span {
    color: #fff;
    padding-right: 10PX;
    font-size: 16PX;
    margin-right: 0;
  }
  p {
    font-size: 16PX;
    color: #4e5557;
  }
}
</style>